import { Container, Row, Col } from 'react-bootstrap';
import './partners.css';

const partners = [
  { name: 'Boltshift', icon: '⚡' },
  { name: 'Lightbox', icon: '📦' },
  { name: 'FeatherDev', icon: '🪶' },
  { name: 'Spherule', icon: '🔮' },
  { name: 'GlobalBank', icon: '🔷' },
  { name: 'Nietzsche', icon: '✳️' },
];

// Duplicate for seamless infinite loop
const track = [...partners, ...partners, ...partners];

export const Partners = () => {
  return (
    <section className="partners-section">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <p className="partners-label">Join in our ever growing client list</p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="px-0">
            <div className="partners-marquee-wrapper">
              <div className="partners-track">
                {track.map((p, i) => (
                  <div className="partner-item" key={i}>
                    <span className="partner-icon">{p.icon}</span>
                    <span className="partner-name">{p.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
